import { Component, OnInit } from '@angular/core';
import { Driver } from '../shared/driver.model';
import { MapObject } from '../shared/mapobject.model';
import { SelectService } from '../core/select.service';
import { DataService } from '../core/data.service';
import { MarkerManager } from '@agm/core';

@Component({
    selector: 'app-display',
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.css']
})

export class DisplayComponent implements OnInit {
    title = 'Drivers';
    // data properties
    driver: Driver;
    drivers: Driver[];
    errorMessage: string;
    // selected properties
    selectedDrivers: Driver[];
    selectedAddress: Driver[];
    selectedMapObject: MapObject;
    // service properties
    mapNotExpanded: boolean;
    isSelected: boolean;

    // map properties
    lat: string |number;
    lng: string |number;
    zoom: string |number;
    // options: google.maps.MapOptions = {
    //     mapTypeId: 'satellite',
    //     zoomControl: false,
    //     scrollwheel: false,
    //     disableDoubleClickZoom: true,
    //     maxZoom: 15,
    //     minZoom: 8
    // };
    origin: any;
    destination: any;
    public transitOptions: any = {
        departureTime: new Date('2018/05/20 13:14'),
        arrivalTime: new Date('2018/05/20 13:30'),
        modes: ['BUS'],
    }

    constructor(
        private dataService: DataService,
        private selectService: SelectService
    ) { }

    ngOnInit() {
        this.selectService.selectedDrivers$.subscribe(
            drivers => {
                this.selectedDrivers = drivers.map(
                    driver => ({ ...driver, driver })
                );
            }
        );
        this.selectService.selectedAddress$.subscribe(
            drivers => {
                this.selectedAddress = drivers.map(
                    driver => ({ ...driver, driver })
                );
            }
        );
        // data methods
        this.dataService.drivers$.subscribe(
            drivers => this.drivers = drivers
        );
        // map methods
        // this.setCurrentLocation();        
        this.zoom = 9;
        this.selectService.selectedMapObject$.subscribe(
            mapObject => {
                if (mapObject) {
                    this.lat = Number(mapObject.lat);
                    this.lng = Number(mapObject.lng);
                } else {
                    this.lat = 50.43878;
                    this.lng = 30.56662;
                }
                // console.log(this.lat + ' ' + this.lng)
            }
        );
        // service methods
        this.mapNotExpanded = true;
        this.getDirection();
    }

    trackByFn(item: any) {
        return item.shipping_id;
    }

    /* get user current location */
    // private setCurrentLocation() {
    //     if ('geolocation' in navigator) {
    //         navigator.geolocation.getCurrentPosition((position) => {
    //             this.lat = position.coords.latitude;
    //             this.lng = position.coords.longitude;
    //             this.zoom = 15;
    //         });
    //     }
    // }

    // clickedMarker(driver: Driver) {
    //   this.selectService.getSelectedDriverId(driver);
    //   this.isSelected = true;
    //   this.selectService.getSelectedState(this.isSelected);
    // }

    clickedMarker(driver: Driver) {
        // this.selectService.getSelectedDriverId(driver);
        // this.isSelected = true;
        // this.selectService.getSelectedState(this.isSelected);
        console.log(`clicked the marker: ${driver}`);
    }

    getDirection() {
        this.origin = {
            lat: 50.41881,
            lng: 30.65509
        }

        this.destination = {
            lat: 50.39041,
            lng: 30.57453
        }
    }


}
